import { render } from "./AddEditSubFranchise.vue?vue&type=template&id=dd78bb06"
import script from "./AddEditSubFranchise.vue?vue&type=script&lang=js"
export * from "./AddEditSubFranchise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__